import { FC, ReactNode, useEffect } from 'react';
import { TeamPlayer, TeamPlayerProps } from '@dreamteam-monorepo/ui';
import { twMerge } from 'tailwind-merge';

type MatchFormationMember = TeamPlayerProps & { id?: string | number };

export interface MatchFormationProps {
  className?: string;
  formation: number[];
  members: MatchFormationMember[];
  actions?: ReactNode;
  onPressPlayer: (
    player: MatchFormationMember,
    playerIndex: number,
    rowIndex: number,
    colIndex: number
  ) => void;
}

export const MatchFormation: FC<MatchFormationProps> = ({
  onPressPlayer,
  className,
  formation,
  members,
  actions,
}) => {
  const fallbackMember: MatchFormationMember = {
    name: 'Add',
    desc: '',
    mode: 'add',
  };

  useEffect(() => {
    const formationLength = formation.reduce((prev, curr) => {
      return prev + curr;
    }, 0);
    if (formationLength !== members.length) {
      console.error('formationLength is not equal to members length');
    }
  }, [formation, members]);

  return (
    <div className={twMerge('flex-0 flex flex-col items-center ', className)}>
      <div className="flex flex-col items-center gap-y-4 md:gap-y-5 md:pl-4">
        {formation.map((row, rowIndex) => {
          const rowStartIndex = formation.slice(0, rowIndex).reduce((sum, num) => sum + num, 0);

          return (
            <div key={rowIndex} className="flex-0 flex flex-row gap-x-2 md:gap-x-5">
              {new Array(row).fill('').map((_, colIndex) => {
                const memberIndex = rowStartIndex + colIndex;
                const member = members[memberIndex] ?? fallbackMember;
                return (
                  <TeamPlayer
                    key={colIndex}
                    descClassName="p-1"
                    nameClassName="px-1 py-0.5"
                    {...member}
                    onPress={() => {
                      onPressPlayer(member, memberIndex, rowIndex, colIndex);
                    }}
                  />
                );
              })}
            </div>
          );
        })}
      </div>
      {actions}
    </div>
  );
};
